import React, {useState, useEffect} from 'react'
import { Select, DatePicker, Checkbox} from 'antd'
import moment from 'moment'
import { listTrackingStatus } from '../../../helpers/filtersTable'
import { getListShippingCarrierApp } from '../../../../services/api/apiFFM'

function BatchShipFilter(props) {
    const { RangePicker } = DatePicker
    const { Option } = Select
    const {
        status, shippingStatus,
        loading, batch, tracking,
        handleChangeStatus,
        handleChangeShippingStatus,
        handleChangeBatch, searchValue,
        handleChangeCreated,
        createdStart,createdEnd,
        boxCarrier, itemType,
        handleChangeBoxCarrier,
        handleChangeItemType,
        handleChangeTracking,
        handleSearchBatch,
        partnerBoxStatus,
        handleChangePartnerBoxStatus,
        // FAC-26443: tạm ẩn filter label thùng
        // labelStatus,
        // handleChangeLabelStatus,
        isFBA,
        handleChangeIsFBA,
        fbaPendingGen,
        handleChangeFbaPendingGen
    } = props
    const dateFormat= "YYYY-MM-DD"
    const dateFilterValue= createdStart&&createdEnd?[moment(createdStart, dateFormat), moment(createdEnd, dateFormat)]:[]
    const [listShippingCarrier, setListShippingCarrier] = useState([])
    const [allShippingCarrier, setAllShippingCarrier] = useState([])

    const fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            setListShippingCarrier(shippingCarriers.filter(i => !!i.is_active) || [])
            setAllShippingCarrier(shippingCarriers || [])
            
        } catch (error) {
            alert(error.message)
        }
    } 

    useEffect(()=>{
        fetchFiltersShippingCarrier()
    },[])

    const shippingCarrierOptions = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i=> ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })) : []

    return (
        <div className='BatchShipFilter TableFilter d-xl-flex justify-content-between align-items-end'>
            <div className="Filter">
                <div className="d-flex flex-wrap justify-content-start">
                    <div className="FilterWrapper FilterOptions mr-2 mb-3">
                        <div className="CustomSelect d-flex align-items-stretch justify-content-end">
                            <Select
                                style={{ width: "460px" }}
                                mode='tags'
                                placeholder='Search: ID lô ship, mã thùng, mã đơn FAC, mã đơn FFM hoặc tracking'
                                onChange={handleChangeBatch}
                                allowClear
                                disabled={loading}
                                open={false}
                                searchValue={searchValue || ''}
                                onSearch={handleSearchBatch}
                                value={batch.length? batch : []}
                            />
                        </div>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Type --"
                            allowClear
                            value={itemType || []}
                            onChange={handleChangeItemType}
                            disabled={loading}
                        >
                            <Option value='order'>Đơn</Option>
                            <Option value='package'>Thùng</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Batch status --"
                            allowClear
                            value={status || []}
                            onChange={handleChangeStatus}
                            disabled={loading}
                        >
                            <Option value='open'>Open</Option>
                            <Option value='confirmed'>Confirmed</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Shipping status --"
                            allowClear
                            value={shippingStatus || []}
                            onChange={handleChangeShippingStatus}
                            disabled={loading}
                        >
                            {!!listTrackingStatus.length && listTrackingStatus.map(i=>(
                                <Option value={i.value} key={i.value}>{i.name}</Option>
                            ))}
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Box Carrier --"
                            value={boxCarrier || []}
                            onChange={handleChangeBoxCarrier}
                            allowClear
                            disabled={loading}
                            showSearch
                            onSearch={(value) => {
                                if (value) {
                                    const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                    setListShippingCarrier(newList)
                                } else { setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active)) }
                            }}
                            onBlur={() => setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                            filterOption={(input, option) => {
                                return option.children.toLowerCase().includes(input.toLowerCase())
                            }}
                        >
                            {!!shippingCarrierOptions.length && shippingCarrierOptions.map((i, index) => (
                                <Option value={i.value} key={index} style={!i.is_active ? {} : { color: '#333' }}>{i.name}</Option>
                            ))}
                            <Option value={'other'} key={'other'}>Other</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <RangePicker
                            id='createdAt'
                            placeholder={['Created start', 'Created end']}
                            ranges={{
                                'Today': [moment().startOf('day'), moment().endOf('day')],
                                'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                                'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                            }}
                            format={dateFormat}
                            onChange={handleChangeCreated}
                            popupStyle={{ maxWidth: '600px' }}
                            disabled={loading}
                            value={dateFilterValue}
                        />
                    </div>
                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "125px" }}
                            placeholder="-- Tracking --"
                            value={tracking!=='' ? tracking : []}
                            onChange={handleChangeTracking}
                            allowClear
                            disabled={loading}
                        >
                            <Option value={false}>Received</Option>
                            <Option value={true} >Not Received</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "250px" }}
                            placeholder="Trạng thái lô ship HW USPS"
                            allowClear
                            value={partnerBoxStatus || []}
                            onChange={handleChangePartnerBoxStatus}
                            disabled={loading}
                        >
                            <Option value='done'>Tạo thùng thành công</Option>
                            <Option value='error'>Lỗi tạo thùng</Option>
                            <Option value='pending'>Chưa tạo thùng</Option>
                        </Select>
                    </div>

                    {/* FAC-26443: tạm ẩn filter "Trạng thái label thùng" — BE chưa hỗ trợ label_status, chờ PO chốt nghiệp vụ
                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Trạng thái label thùng --"
                            allowClear
                            value={labelStatus || []}
                            onChange={handleChangeLabelStatus}
                            disabled={loading}
                        >
                            <Option value='has_label'>Đã có label</Option>
                            <Option value='no_label'>Chưa có label</Option>
                        </Select>
                    </div>
                    */}
                    <div className='FilterOptions mr-2 mb-3 d-flex align-items-center'>
                        <Checkbox
                            checked={isFBA}
                            onChange={(e) => handleChangeIsFBA(e.target.checked)}
                            disabled={loading}
                        >
                            FBA
                        </Checkbox>
                        <Checkbox
                            className='ml-3'
                            checked={!!fbaPendingGen}
                            onChange={(e) => handleChangeFbaPendingGen(e.target.checked)}
                            disabled={loading}
                        >
                            FBA chờ gen label
                        </Checkbox>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BatchShipFilter